"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zh = void 0;
var zh = {
  showTable: {
    totalPre: '总计',
    totalSuf: '条数据',
    confirmDel: '确认删除吗？',
    delSuccess: '删除成功',
    addSuccess: '添加成功',
    updateSuccess: '修改成功',
    action: '操作',
    view: '查看',
    edit: '编辑',
    del: '删除',
    add: '添加',
    export: '导出',
    import: '导入'
  },
  advanceFilter: {
    addFilter: '添加筛选条件',
    title: '筛选条件',
    clear: '清空',
    filter: '筛选',
    del: '删除'
  },
  showCols: {
    title: '显示字段',
    checkAll: '全选',
    searchCheckAll: '搜索结果全选'
  },
  fullScreen: {
    title: '全屏'
  },
  types: {
    includes: '包含',
    equals: '等于',
    notEqual: '不等于',
    range: '选择范围',
    gt: '大于',
    gte: '大于等于',
    lt: '小于',
    lte: '小于等于'
  }
};
exports.zh = zh;